/**
 * Image transform information
 */
export default class ImageTransform {
	/**
	 * Class constructor
	 *
	 * @param {string} [data] Serialized transform data
	 */
	constructor(data = '') {
		/**
		 * Translate image by X axis
		 *
		 * @type {?number}
		 */
		this.translateX = null;

		/**
		 * Translate image by Y axis
		 *
		 * @type {?number}
		 */
		this.translateY = null;

		/**
		 * Flip image by X axis
		 *
		 * @type {?boolean}
		 */
		this.flipX = null;

		/**
		 * Flip image by Y axis
		 *
		 * @type {?boolean}
		 */
		this.flipY = null;

		if (data !== '') {
			this.setData(data);
		}
	}

	/**
	 * Sets image transform as serialized data
	 *
	 * @param {string} data
	 * @returns {ImageTransform}
	 */
	setData(data) {
		for (let item of data.split(',')) {
			let m = item.match(/^([xy])(-?\d{1,5})|(fx|fy)$/);
			if (m === null) {
				continue;
			}

			if (m[1]) {
				if (m[1] === 'x') {
					this.translateX = parseInt(m[2]);
				} else if (m[1] === 'y') {
					this.translateY = parseInt(m[2]);
				}
			} else if (m[3] === 'fx') {
				this.flipX = true;
			} else if (m[3] === 'fy') {
				this.flipY = true;
			}
		}
		return this;
	}

	/**
	 * Returns serialized transform information
	 *
	 * @returns {string}
	 */
	getData() {
		let out = [];
		if (this.translateX !== null && this.translateX !== 0) {
			out.push('x' + Math.round(this.translateX));
		}

		if (this.translateY !== null && this.translateY !== 0) {
			out.push('y' + Math.round(this.translateY));
		}

		if (this.flipX === true) {
			out.push('fx');
		}

		if (this.flipY === true) {
			out.push('fy');
		}
		return out.join(',');
	}

	/**
	 * Copies transform values from another object
	 *
	 * @param {ImageTransform} transform
	 * @returns {ImageTransform}
	 */
	copyFrom(transform) {
		if (transform.translateX !== null) {
			this.translateX = transform.translateX;
		}

		if (transform.translateY !== null) {
			this.translateY = transform.translateY;
		}

		if (transform.flipX !== null) {
			this.flipX = transform.flipX;
		}

		if (transform.flipY !== null) {
			this.flipY = transform.flipY;
		}
		return this;
	}

	/**
	 * Merges transform values from another object
	 *
	 * @param {ImageTransform} transform
	 * @returns {ImageTransform}
	 */
	mergeFrom(transform) {
		if (transform.translateX !== null) {
			this.translateX = (this.translateX || 0) + transform.translateX;
		}

		if (transform.translateY !== null) {
			this.translateY = (this.translateY || 0) + transform.translateY;
		}

		if (transform.flipX !== null) {
			this.flipX = transform.flipX;
		}

		if (transform.flipY !== null) {
			this.flipY = transform.flipY;
		}
		return this;
	}

	/**
	 * Returns copy of this object
	 *
	 * @returns {ImageTransform}
	 */
	clone() {
		return new ImageTransform(this.getData());
	}
}
